import address from '../../../api/home/address'

// initial state
const state = {
  address: {}
}

// getters
const getters = {
  address: (state, getters) => {
    if (state.address.BUILDING === null || state.address.BUILDING === undefined) {
      return {ADDRESS: ''}
    }
    const add = {
      ADDRESS: state.address.BLK_NO + ' ' + state.address.ROAD_NAME + ' ' + state.address.BUILDING
    }
    return add
  }
}

// actions
const actions = {
  getAddress ({ commit }, postalCode) {
    return new Promise((resolve, reject) => {
      if (postalCode.length !== 6) {
        resolve(null)
      } else {
        address.getAddress(postalCode)
          .then(res => {
            if (res.found >= 1 && res.results.length > 0) {
              resolve(res.results[0])
              commit('setAddress', res.results[0])
            } else {
              commit('setAddress', {})
              resolve(null)
            }
          })
          .catch((error) => {
            reject(error)
          })
      }
    })
  }
}

// mutations
const mutations = {
  setAddress (state, res) {
    state.address = res
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/home/address.js